import {observable, computed, autorun, action} from 'mobx';
import moment from 'moment';
import {TIME_UNIT_ID} from '../model/const';

export class VObjectDetails {

  /*@computed get objectDetailsData() {
    return this.rentalObject.data;
  }*/
  @observable bestSelectableOffer;
  
  constructor(flasher, rentalObject, masterData, organization, businessUnit, allotmentDetails, searchForm, bestOffers) {
    this.flasher = flasher;
    this.rentalObject = rentalObject;
    this.masterData = masterData;
    this.organization = organization;
    this.businessUnit = businessUnit;
    this.allotmentDetails = allotmentDetails;
    this.searchForm = searchForm;
    this.bestOffers = bestOffers;

    this.reactions = [];
  }


  @action.bound stopReactions() {
    this.reactions.forEach(ar => ar());
    this.reactions = [];
  }

  @action.bound stop() {
    this.stopReactions();
  }

  @action.bound goSelection() {
    const startDate = this.searchForm.startDate || window.sessionStorage.searchStartDate;
    const endDate = this.searchForm.endDate || window.sessionStorage.searchEndDate;     
    this.allotmentDetails.goSelection({start: moment(startDate), end: moment(endDate)});
  }

  @action.bound changeViewType() {
    this.allotmentDetails.changeViewType();
    this.goSelection();
  }

  async startOrUpdate({orgId, objId}) {
    this.orgId = orgId;
    this.objId = objId;
    this.allotmentDetails.orgId = orgId;
    this.allotmentDetails.objId = objId;
    //debugger
    const startDate = this.searchForm.startDate || window.sessionStorage.searchStartDate;
    const endDate = this.searchForm.endDate || window.sessionStorage.searchEndDate; 
    this.allotmentDetails.loadedForStart = false;
    try {
      this.flasher.setOther('Loading.');
      await Promise.all([
        this.masterData.cFetch(),
        this.organization.cFetch({orgId}),
        this.rentalObject.cFetch({orgId, objId}),
        this.bestOffers.cFetch({
          startDate: startDate,  
          endDate: endDate, 
          organizationId: this.orgId, 
          objectId: this.objId, 
          timeUnit: this.searchForm.timeUnit || window.sessionStorage.searchTimeUnitId, 
          oldStartDate: undefined, 
          oldEndDate: undefined,
        })
      ]); 

      if(this.bestOffers.bestOfferItems.length > 0 && this.bestOffers.bestOfferItems[0].bestSelectableOffer) {
        this.bestSelectableOffer = this.bestOffers.bestOfferItems[0].bestSelectableOffer;
      }

      //this.allotmentDetails.setCalendarViewTypeByTUId(this.organization.refAllotmentTimeUnitId);
      this.allotmentDetails.setCalendarViewTypeByTimespan(startDate, endDate);
      this.allotmentDetails.setCalendarDefaultDate((startDate ? moment(startDate) : moment()));
      await this.businessUnit.cFetch({businessUnitId: this.rentalObject.businessUnitId}); 
      await this.allotmentDetails.loadDataForView();
    }
    catch(e) {
      this.flasher.handleError(e);
    }        
    finally {
      this.flasher.setOther();
    }
  }

  @computed get selectionStartDate() {
    return moment(this.searchForm.startDate);
    // if(this.bestSelectableOffer) {
    //   return moment(this.bestSelectableOffer.StartDate)
    // } else if(this.searchForm.startDate) {
    //   return moment(this.searchForm.startDate);
    // } 
  }

  @computed get selectionEndDate() {
    return moment(this.searchForm.endDate);
    // if(this.bestSelectableOffer) {
    //   return moment(this.bestSelectableOffer.EndDate)
    // } else if(this.searchForm.endDate) {
    //   return moment(this.searchForm.endDate);
    // }
  }
} 


// WEBPACK FOOTER //
// ./src/view/VObjectDetails.js